<template>
    <div id="overview">
        <section class="section">
            <div class="container">
                <h2 class="section-title" v-scroll-reveal>
                    <span class="_order">01</span>
                    <span class="_title" v-html="$t('Overview')"></span>
                </h2>
            
                <div class="flex flex-wrap md:items-center">
                    <div class="w-full md:w-1/2">
                        <h3 class="section-subtitle mb-base md:mb-0" v-scroll-reveal v-html="$t('index.overview.title')"></h3>
                    </div>

                    <div class="w-full md:w-1/2 xl:w-2/5 md:pl-lg xl:ml-auto">
                        <p v-scroll-reveal v-html="$t('index.overview.text')"></p>
                    </div>
                </div>
            </div>
        </section> 

        <section class="section section-cover">
            <figure style="background-image: url(/img/11-okolis.jpg)"></figure>
        </section>

        <section class="section">
            <div class="container">
                <div class="flex flex-wrap xl:items-center -mx-2 mb-lg xl:mb-gap-lg fhd:mb-gap-xl">
                    <div class="w-full xl:w-3/5 px-2">
                        <figure class="floating-img shadow-lg" v-scroll-reveal style="background-image: url(/img/7-bazen.jpg)"></figure>
                    </div>

                    <div class="w-full md:w-3/4 xl:w-2/5 px-2 xl:text-right">
                        <h3 class="section-subtitle fhd:mb-gap-lg" v-scroll-reveal v-html="$t('index.overview.title-2')"></h3>
                    </div>
                </div>

                <div v-scroll-reveal v-html="$t('index.overview.text-2')"></div>
            </div>
        </section>

        <section class="section bg-secondary">
            <div class="container">
                <div class="flex flex-wrap -mx-2 -mb-base md:-mb-lg xl:-mb-gap">
                    <div class="w-1/2 md:w-1/3 px-2 mb-base md:mb-lg xl:mb-gap">
                        <div class="icon-box" v-scroll-reveal>
                            <figure class="_icon">
                                <img src="/svg/group.svg" alt="">
                            </figure>
                            <span class="_label" v-html="$t('index.overview.label-1')"></span>
                        </div>
                    </div>
            
                    <div class="w-1/2 md:w-1/3 px-2 mb-base md:mb-lg xl:mb-gap">
                        <div class="icon-box" v-scroll-reveal>
                            <figure class="_icon">
                                <img src="/svg/bathroom.svg" alt="">
                            </figure>
                            <span class="_label" v-html="$t('index.overview.label-2')"></span>
                        </div>
                    </div>

                    <div class="w-1/2 md:w-1/3 px-2 mb-base md:mb-lg xl:mb-gap">
                        <div class="icon-box" v-scroll-reveal>
                            <figure class="_icon">
                                <img src="/svg/vineyard.svg" alt="">
                            </figure>
                            <span class="_label" v-html="$t('index.overview.label-3')"></span>
                        </div>
                    </div>

                    <div class="w-1/2 md:w-1/3 px-2 mb-base md:mb-lg xl:mb-gap">
                        <div class="icon-box" v-scroll-reveal>
                            <figure class="_icon">
                                <img src="/svg/bedroom.svg" alt="">
                            </figure>
                            <span class="_label" v-html="$t('index.overview.label-4')"></span>
                        </div>
                    </div>

                    <div class="w-1/2 md:w-1/3 px-2 mb-base md:mb-lg xl:mb-gap">
                        <div class="icon-box" v-scroll-reveal>
                            <figure class="_icon">
                                <img src="/svg/pool.svg" alt="">
                            </figure>
                            <span class="_label" v-html="$t('index.overview.label-5')"></span>
                        </div>
                    </div>

                    <div class="w-1/2 md:w-1/3 px-2 mb-base md:mb-lg xl:mb-gap">
                        <div class="icon-box" v-scroll-reveal>
                            <figure class="_icon">
                                <img src="/svg/kitchen.svg" alt="">
                            </figure>
                            <span class="_label" v-html="$t('index.overview.label-6')"></span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {}
</script>
